import { A11yModule } from '@angular/cdk/a11y';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogConfig,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslationParameters } from 'models';

/** Confirmation Dialog Data. */
export interface ConfirmationDialogData {
  /** Cancel action button text. */
  cancelActionText: string;
  /** Confirm action button text. */
  confirmActionText: string;
  /** Dialog Contents (translation key or string). */
  contents: string;
  /** Dialog Title (translation key or string). */
  title: string;
  /** Optional i18n parameters for dynamic content. */
  contentsParams?: TranslationParameters;
  /** Optional i18n parameters for title. */
  titleParams?: TranslationParameters;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    A11yModule,
    TranslocoModule,
    MatDialogClose,
  ],
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: ConfirmationDialogData
  ) {}

  /**
   * Opens the dialog.
   *
   * @param dialogService MatDialog service reference to open the dialog.
   * @param config Optional dialog configuration passed to open.
   * @returns A reference to the opened dialog.
   */
  static open(
    dialogService: MatDialog,
    config?: MatDialogConfig<ConfirmationDialogData> | undefined
  ) {
    return dialogService.open<
      ConfirmationDialogComponent,
      ConfirmationDialogData,
      boolean
    >(ConfirmationDialogComponent, config);
  }
}
